import gql from "graphql-tag";

export const GET_PHOTO_ROYALTIES_STATEMENT_ALL = gql`
    query photoRoyaltyStatementsAndTotal($username: String!) {
        photoRoyaltyStatementsAndTotal(username: $username) {
            ok
            errors
            statements {
                items {
                    month
                    totalEarned
                    totalPaid
                    insightsExist
                    freeDownloadCount
                    largeSales
                    fullResSales
                    premiumPhotoSales
                    standardPhotoSales
                    creatorProDownloads
                    largePhotoEarnings
                    fullResPhotoEarnings
                    standardPhotoEarnings
                    premiumPhotoEarnings
                    creatorProEarnings
                }
                totalCount
            }
        }
    }
`;

export const GET_POOL_PHOTO_ROYALTY_STATEMENTS = gql`
    query getPoolPhotoRoyaltyStatements($username: String) {
        royaltyStatements(username: $username) {
            ok
            errors
            statements {
                photoInsightsExist
                earnings {
                    subscription {
                        photoEarnings
                    }
                    purchase {
                        premiumPhotoEarnings
                        standardPhotoEarnings
                    }
                }
                payout {
                    paypalEmail
                    earnings {
                        photo
                    }
                    createdAt
                    payoutDate
                    paypalEmail
                }
                paypalEmail
                createdAt
                royaltiesDate
                counts {
                    subscription {
                        photoCount
                    }
                    purchase {
                        premiumPhotoCount
                        standardPhotoCount
                    }
                    free {
                        photoCount
                    }
                }
            }
        }
    }
`;
